module.exports = __webpack_public_path__ + "static/media/BG-03.978b3f27.jpg";